<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="class-schedule"
          :title="title"
          :url="url"
          :columns="columns"
          :filter="filter"
          :disable-create-bulky="false"
          :on-click-create-bulky="onClickCreateBulky"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.price`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.price) }}
          </div>          
        </template>
        <template v-slot:action>
            <v-col md="3">
              <v-select
                label="Kelas"
                required
                dense
                outlined
                v-model="filterClass"
                :items="listClassType"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-select>
            </v-col>
            <v-col md="3">
              <v-select
                label="Instruktur"
                required
                dense
                outlined
                v-model="filterClassInstructor"
                :items="listClassInstructor"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-select>
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDate"
              ></date-picker>
            </v-col>
          </template>
      </datatable>
      </div>
    </div>
    <form-data ref="form" module="class-schedule" @success="formSuccess" />
    <form-data-bulky ref="formbulky" module="class-schedule" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="class-schedule"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormData from "./Form";
import FormDataBulky from "./FormBulky";
import ApiService from "@/core/services/api.service";
import Moment from "moment";

export default {
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Paket", route: "" },
      { title: "Jadwal Kelas" }
    ]);
    this.filterBy();
    const classType = await ApiService.get("class-type/list");
    this.listClassType = classType.data;

    const classInstructor = await ApiService.get("class-instructor/list");
    this.listClassInstructor = classInstructor.data;

  },
  data() {
    return {
      title: "Jadwal Kelas",
      url: "class-schedule/data",
      filterClass: null,
      filterClassInstructor: null,
      listClassInstructor: [],
      filterDate: null,
      filter: null,
      listClassType: [],
      columns: [
        {
          value: "id"
        },
        {
          text: "Kelas",
          value: "class_type_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Instruktur",
          value: "class_instructor_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Tanggal Kelas",
          value: "class_date",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Mulai",
          value: "start_time",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Selesai",
          value: "end_time",
          sortable: true,
          searchable: false
        },
        {
          text: "Kuota",
          value: "quota",
          sortable: true,
          searchable: false
        },
        {
          text: "Total Peserta",
          value: "total_booking",
          sortable: false,
          searchable: false
        },
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickCreateBulky() {
      this.$refs.formbulky.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    filterBy() {
      let finalFilter = [];

      if (this.filterClass) {
        finalFilter = [
          ...finalFilter,
          {
            column: "class_type_id",
            value: this.filterClass,
          }
        ];
      }
      if (this.filterClassInstructor) {
        finalFilter = [
          ...finalFilter,
          {
            column: "class_instructor_id",
            value: this.filterClassInstructor,
          }
        ];
      }
      if (this.filterDate) {
        finalFilter = [
          ...finalFilter,
          {
            column: "class_date",
            value: Moment(this.filterDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
          }
        ];
      }

      if (finalFilter.length > 0) {
        this.filter = finalFilter;
      } else {
        this.filter = null;
        this.filterSlug = null;
      }
    },
  },
  watch: {
    filterClass(v) {
      if (v) {
        this.filterClass = v;
      } else {
        this.filterClass = null;
      }

      this.filterBy();
    },
    filterClassInstructor(v) {
      if (v) {
        this.filterClassInstructor = v;
      } else {
        this.filterClassInstructor = null;
      }

      this.filterBy();
    },
    filterDate(v) {
      if (v) {
        this.filterDate = v;
      } else {
        this.filterDate = null;
      }
      this.filterBy();
    }
    
  },
  components: {
    Datatable,
    DeleteDialog,
    FormData,
    FormDataBulky
  }
};
</script>
